import { render } from "./Outro.vue?vue&type=template&id=5d47b54e&scoped=true"
import script from "./Outro.vue?vue&type=script&lang=js"
export * from "./Outro.vue?vue&type=script&lang=js"

import "./Outro.vue?vue&type=style&index=0&id=5d47b54e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d47b54e"]])

export default __exports__